<template>
<b-card>
   <b-tabs @activate-tab="changeTabs($event)" content-class="mt-3">
    <b-tab title="گزارش ریالی" active>
        <list-table
          url="transactionSummery?money_type=rial"
          title="تعداد تراکنش های ریالی و کارمزد هایش"
          :fields="fields"
          :params="params"
          :excelroute="true"
        ></list-table>
    </b-tab>
    <b-tab title="گزارش stripe">
      <list-table
          url="transactionSummery?money_type=stripe"
          title="تعداد تراکنش های stripe و کارمزد هایش"
          :fields="fields"
          :params="params"
          :excelroute="true"
          v-if="enableStripe"
        ></list-table>
    </b-tab>
    <b-tab title="گزارش perfectmoney">
      <list-table
          url="transactionSummery?money_type=perfectmoney"
          title="تعداد تراکنش های perfectmoney  و کارمزد هایش"
          :fields="fields"
          :params="params"
          :excelroute="true"
          v-if="enablePerfectmoney"
        ></list-table>
    </b-tab>
  </b-tabs>
</b-card>
 
</template>
<script>
import TableShowData from "../../components/table";
export default {
  name: "CalcIncome",
  data() {
    return {
      url: "transactionSummery",
      fields: [
        { key: "website_name", label: "نام وبسایت" },
        { key: "moneytype", label: "واحد پولی" },
        { key: "count", label: "تعداد تراکنش ها" ,sortable: true},
        {
          key: "amount",
          label: "مجموع کارمزد تراکنش ها",
          formatter(value, key, item) {
            return Number(value ? value : 0).toLocaleString();
          },
          sortable: true
        },
        {
          key: "SumCost",
          label: "مجموع مبلغ تراکنش ها",
          formatter(value, key, item) {
            return Number(parseInt(value)).toLocaleString();
          },
          sortable: true
        },
        {
          key: "ShouldBe",
          label: "میزان کارمزد",
          formatter(value, key, item) {
            return Number(parseInt(value)).toLocaleString();
          },
          sortable: true
        },
      ],
      params: [
        { field: "datefrom", type: "date-picker", label: "از تاریخ" },
        { field: "dateto", type: "date-picker", label: "تا تاریخ" },
      ],
      enableStripe:false,
      enablePerfectmoney:false,
    };
  },
  components: {
    "list-table": TableShowData,
  },
  methods:{
    changeTabs(e){
      console.log("eeeee:",e);
      this.enablePerfectmoney
      e==1 ? this.enableStripe=true  : this.enablePerfectmoney=true;
    }
  }
};
</script>